import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';
@Component({
  selector: 'app-assurance-prevoyance-ijh',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
  templateUrl: './assurance-prevoyance-ijh.component.html',
  styleUrls: ['./assurance-prevoyance-ijh.component.scss']
})
export class AssurancePrevoyanceIjhComponent {
  title = 'Assurance Prévoyance IJH';
  subtitle = 'Indemnités Journalières en cas d\'Hospitalisation : Préservez vos revenus';
  heroImage = 'assets/static_pages_images/Prévoyance-IJH.jpg';
  
  breadcrumbs = [
    { label: 'Particuliers', link: undefined },
    { label: 'Assurance Prévoyance IJH', link: undefined }
  ];

  prevPage = { title: 'Prévoyance GAV',
    link: '/assurance-prevoyance-gav'
  };

  nextPage = { title: 'Prévoyance Obsèque',
    link: '/assurance-prevoyance-obseque'
  };

  constructor(private router: Router) {}

  navigateToComparison(): void {
    this.router.navigate(['/cac/comparaison']);
  }

  navigateToDevis(): void {
    this.router.navigate(['/devis']);
  }
}

